// Popup used by the Bank Statement, Monthly Bank Summary and Profit pages.
//
// Rendered with createPortal into document.body with fully inline overlay /
// box positioning, so global ".modal" CSS and the Accounting tab container
// can never hide or clip it.
//
//   <BankPopup open onClose={...} width={920} layer={1} finStyles>
//     ...head / body / foot...
//   </BankPopup>
//
// layer 1 = normal popup (z 999998/999999), layer 2 = popup on top of a popup
// (z 1999998/1999999). finStyles wraps the content in .fin-page so the
// FinancePages.css look (fin-btn, fin-input, fin-modal__head…) applies.

import React from "react";
import { createPortal } from "react-dom";

export default function BankPopup({ open = true, onClose, width = 920, layer = 1, finStyles = false, label = "Popup", children }) {
  if (!open || typeof document === "undefined") return null;
  const base = layer === 2 ? 1999998 : 999998;

  const overlay = (
    <div
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && onClose) onClose();
      }}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.55)",
        zIndex: base,
      }}
    />
  );

  const box = (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={label}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        zIndex: base + 1,
        width: `min(${width}px, calc(100vw - 24px))`,
        maxHeight: "calc(100vh - 32px)",
        background: "#fff",
        borderRadius: 14,
        boxShadow: "0 24px 70px rgba(0,0,0,0.35)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        color: "#111827",
        textAlign: "left",
      }}
    >
      {children}
    </div>
  );

  return createPortal(
    finStyles ? (
      <div className="fin-page" style={{ padding: 0, background: "transparent", minHeight: 0 }}>
        {overlay}
        {box}
      </div>
    ) : (
      <>
        {overlay}
        {box}
      </>
    ),
    document.body
  );
}
